// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1lW-V","overflowing":"ReadFullNote_overflowing__8Il63"};